// VEPC Gestão — Integração Oficial com Firebase Authentication Client SDK
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut,
  onAuthStateChanged,
  connectAuthEmulator
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDJAOj_s8uYMTpHuK4SQZ5VnsrSRwbPHSc",
  authDomain: "vepc-gestao-dev.firebaseapp.com",
  projectId: "vepc-gestao-dev",
  storageBucket: "vepc-gestao-dev.firebasestorage.app",
  messagingSenderId: "939068244782",
  appId: "1:939068244782:web:vepcgestao"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

// Conexão obrigatória ao Firebase Auth Emulator em ambiente local (localhost / 127.0.0.1)
const isLocalHost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

let isEmulatorConnected = false;

if (isLocalHost) {
  try {
    const emulatorUrl = window.__FIREBASE_AUTH_EMULATOR_URL__ || 'http://127.0.0.1:9099';
    connectAuthEmulator(auth, emulatorUrl, { disableWarnings: true });
    isEmulatorConnected = true;
    console.info('[Firebase Auth] Conectado estritamente ao Emulator Local:', emulatorUrl);
  } catch (e) {
    console.warn('[Firebase Auth] Aviso ao conectar ao emulator:', e.message);
  }
}

// Helper para obter o link de verificação gerado pelo emulador local
export async function obterLinkVerificacaoEmulador(email) {
  if (!isLocalHost) return null;
  try {
    const res = await fetch('http://127.0.0.1:9099/emulator/v1/projects/vepc-gestao-dev/oobCodes');
    if (!res.ok) return null;
    const data = await res.json();
    const codes = data.oobCodes || [];
    // Pega o código mais recente para o e-mail solicitado
    for (let i = codes.length - 1; i >= 0; i--) {
      if (codes[i].email.toLowerCase() === email.toLowerCase() && codes[i].requestType === 'VERIFY_EMAIL') {
        return codes[i].oobLink;
      }
    }
    return codes[codes.length - 1]?.oobLink || null;
  } catch (err) {
    console.warn('[Firebase Auth Emulator] Falha ao consultar oobCodes:', err);
    return null;
  }
}

// Operações oficiais de autenticação do operador proprietário
export async function obterTokenAdminAtual(forceRefresh = false) {
  if (!auth.currentUser) return null;
  try {
    const token = await auth.currentUser.getIdToken(forceRefresh);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('vepc_admin_firebase_token', token);
    }
    return token;
  } catch (err) {
    console.warn('[Firebase Auth] Falha ao atualizar ID token:', err.message);
    return null;
  }
}

export async function loginProprietarioFirebase(email, password) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  const token = await cred.user.getIdToken(true);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('vepc_admin_firebase_token', token);
  }
  return cred.user;
}

export async function logoutProprietarioFirebase() {
  try {
    await signOut(auth);
  } finally {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('vepc_admin_firebase_token');
    }
  }
}

export {
  auth,
  isLocalHost,
  isEmulatorConnected,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut,
  onAuthStateChanged
};
